import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-info-circle",
  "use": "icon-info-circle-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-info-circle\"><path fill-rule=\"evenodd\" d=\"M8.116 5.759a.884.884 0 101.768 0 .884.884 0 00-1.768 0zM9 .75a8.25 8.25 0 11-.001 16.501A8.25 8.25 0 019 .75zm0 1.4a6.852 6.852 0 000 13.7 6.852 6.852 0 000-13.7zm.442 5.671c.081 0 .147.067.147.148v5.009a.148.148 0 01-.147.147h-.884a.148.148 0 01-.147-.147v-5.01c0-.08.066-.147.147-.147h.884z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol